import { secondsToMinutes } from "@plasma/utils/time";
import { ChevronDown, ChevronRight, Timer } from "lucide-react";

import type { TimingThresholdsState } from "~/components/stations/station-edit-types";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "~/components/ui/collapsible";
import { Input } from "~/components/ui/input";
import { Label } from "~/components/ui/label";

interface KdsTimingSectionProps {
  timingThresholds: TimingThresholdsState;
  setTimingThresholds: (thresholds: TimingThresholdsState) => void;
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
}

export function KdsTimingSection({
  timingThresholds,
  setTimingThresholds,
  isOpen,
  setIsOpen,
}: KdsTimingSectionProps) {
  return (
    <Collapsible onOpenChange={setIsOpen} open={isOpen}>
      <CollapsibleTrigger asChild>
        <div className="border-border hover:bg-accent/50 flex cursor-pointer items-center justify-between rounded-xl border px-4 py-3">
          <div className="flex items-center gap-3">
            <Timer className="text-muted-foreground h-5 w-5" />
            <div>
              <p className="font-medium">Timing Thresholds</p>
              <p className="text-muted-foreground text-sm">
                Warning times for orders
              </p>
            </div>
          </div>
          {isOpen ? (
            <ChevronDown className="text-muted-foreground h-5 w-5" />
          ) : (
            <ChevronRight className="text-muted-foreground h-5 w-5" />
          )}
        </div>
      </CollapsibleTrigger>
      <CollapsibleContent>
        <div className="border-border bg-accent/30 mt-2 space-y-4 rounded-xl border p-4">
          <div className="grid grid-cols-2 gap-4">
            <div className="flex flex-col gap-2">
              <Label>Caution (Yellow)</Label>
              <div className="flex items-center gap-2">
                <Input
                  className="w-20"
                  min={1}
                  onChange={(e) =>
                    setTimingThresholds({
                      ...timingThresholds,
                      cautionSeconds:
                        Number.parseInt(e.target.value || "0", 10) * 60,
                    })
                  }
                  type="number"
                  value={secondsToMinutes(timingThresholds.cautionSeconds)}
                />
                <span className="text-muted-foreground text-sm">minutes</span>
              </div>
              <p className="text-muted-foreground text-xs">
                Orders turn yellow after this time
              </p>
            </div>
            <div className="flex flex-col gap-2">
              <Label>Late (Red)</Label>
              <div className="flex items-center gap-2">
                <Input
                  className="w-20"
                  min={1}
                  onChange={(e) =>
                    setTimingThresholds({
                      ...timingThresholds,
                      lateSeconds:
                        Number.parseInt(e.target.value || "0", 10) * 60,
                    })
                  }
                  type="number"
                  value={secondsToMinutes(timingThresholds.lateSeconds)}
                />
                <span className="text-muted-foreground text-sm">minutes</span>
              </div>
              <p className="text-muted-foreground text-xs">
                Orders turn red after this time
              </p>
            </div>
          </div>
        </div>
      </CollapsibleContent>
    </Collapsible>
  );
}
